<template>
    <div class="user-left-box">
        <div class="user-box" v-if="user">
            <div class="avatar f0" flex="cross:center main:center">
                <img :src="$util.img(user ? user.avatar : '')" />
            </div>
            <div class="name">{{user.nickname}}</div>
            <div class="nav-list">
                <div class="nav" :class="{active: active == 1}" flex="cross:center" @click="$router.push({
                    name: 'Collect'
                })">
                    <img src="@/assets/image2/user-index-1.png" />
                    <div class="text">{{$lang.get().myCollection}}</div>
                </div>
                <div class="nav" :class="{active: active == 2}" flex="cross:center" @click="$router.push({
                    name: 'Track'
                })">
                    <img src="@/assets/image2/user-index-2.png" />
                    <div class="text">{{$lang.get().myFoot}}</div>
                </div>
                <div class="nav" :class="{active: active == 3}" flex="cross:center" @click="$router.push({
                    name: 'UserContact'
                })">
                    <img src="@/assets/image2/user-index-3.png" />
                    <div class="text">{{$lang.get().contactCustomerService}}</div>
                </div>
                <div class="nav" :class="{active: active == 4}" flex="cross:center" @click="$router.push({
                    name: 'UserSettle'
                })">
                    <img src="@/assets/image2/user-index-4.png" />
                    <div class="text">{{$lang.get().enterpriseSettled}}</div>
                </div>
                <div class="nav" :class="{active: active == 5}" flex="cross:center" @click="$router.push({
                    name: 'UserSet'
                })">
                    <img src="@/assets/image2/user-index-5.png" />
                    <div class="text">{{$lang.get().settings}}</div>
                </div>
            </div>
        </div>


        <div class="product-list" v-if="showProduct">
            <div class="product-title-box">
                <div class="title-info" flex="cross:center main:center">{{$lang.get().recommendedProducts}}</div>
            </div>
            <div class="products">
                <div class="product-line" flex="main:justify" v-for="(c,i) in products" :key="i">
                    <div class="product cp" v-for="(product, j) in c" :key="j" @click="showProductInfo(product)">
                        <div class="image f0">
                            <img :src="$util.img(product.image)"/>
                        </div>
                        <div class="name">{{$lang.getLang() == 'cn' ? product.name : product.name_en}}</div>
                    </div>
                </div>
            </div>
        </div>
        <ProductDetail v-if="showProductDialog" :product="currentProduct"></ProductDetail>
    </div>
</template>

<script>
export default {
    props: {
        showProduct: {
            type: Boolean,
            default: true
        },
        user: {
            type: Object,
            default: null
        },
        active: {
            type: Number,
            default: 1
        }
    },
    data(){
        return {
            products: [],
            currentProduct: null,
            showProductDialog: false,
        }
    },
    mounted(){
        this.getProducts()
    },
    methods: {
        async getProducts(){
            let res = await this.$api.rApi('product/index/recommend/lists', {
            })
            if(res.status == 1){
                this.products = res.data
            }
        },
        showProductInfo(row){
            // this.currentProduct = row
            // this.showProductDialog = true
            this.$router.push({
                name: 'Search',
                query: {
                    keyword: this.$lang.getLang() == 'cn' ? row.name : row.name_en
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
    .user-left-box{
        width: 345px;
        .user-box{
            width: 345px;
            height: 628px;
            background: #FFFFFF;
            box-shadow: 0px 10px 20px 1px rgba(0,0,0,0.05);
            border-radius: 10px 10px 10px 10px;
            box-sizing: border-box;
            padding-top: 46px;
            .avatar{
                margin-bottom: 20px;
                img{
                    width: 122px;
                    height: 122px;
                    border-radius: 61px;
                }
            }
            .name{
                font-family: Arial, Arial;
                font-weight: bold;
                font-size: 14px;
                color: #000000;
                text-align: center;
                margin-bottom: 50px;
            }
            .nav-list{
                padding-left: 55px;
                .nav{
                    cursor: pointer;
                    margin-bottom: 55px;
                    img{
                        width: 14px;
                        height: 14px;
                        margin-right: 10px;
                    }
                    .text{
                        font-family: Arial, Arial;
                        font-weight: 400;
                        font-size: 16px;
                        color: #000000;
                    }
                    &.active{
                        .text{
                            color: #216347;
                            font-weight: bold;
                        }
                    }
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
            }
        }
    }

        .product-list{
            width: 345px;
            height: 2054px;
            background: #FFFFFF;
            box-shadow: 0px 10px 20px 1px rgba(0,0,0,0.05);
            border-radius: 10px 10px 10px 10px;
            box-sizing: border-box;
            padding-top: 30px;
            margin-top: 20px;
            margin-bottom: 50px;
            .product-title-box{
                margin: 0 auto;
                width: 189px;
                height: 51px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid rgba(#000, 0.15);
                margin-bottom: 36px;
                .title-info{
                    width: 212px;
                    height: 32px;
                    background: #006346;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 10px;
                    margin-left: -14px;
                    font-family: Arial, Arial;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                }
            }
            .product-line{
                margin: 16px 32px;
                border-bottom: 1px solid rgba(#707070, 0.13);
                &:last-child{
                    border-bottom: 0;
                }
                .product{
                    .image{
                            width: 127px;
                            height: 127px;
                            border-radius: 10px  10px  10px  10px;
                            border: 1px solid #E9E9E9;
                        img{
                            border-radius: 10px  10px  10px  10px;
                            width: 127px;
                            height: 127px;
                                transition: .3s;
                            box-sizing: border-box;
                            &:hover{
                                transition: .3s;
                                width: 137px;
                                height: 137px;
                                margin-top: -5px;
                                margin-left: -5px;
                            }
                        }
                    }
                    .name{
                        padding-top:10px;
                        width: 127px;
                        font-family: Arial, Arial;
                        font-weight: 400;
                        font-size: 12px;
                        color: #333333;
                        padding-bottom: 23px;
                        text-align: center;
                    }
                }
            }
        }
</style>


// WEBPACK FOOTER //
// src/components/NewUserLeft.vue